export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/menu/dashboard/dashboard.vue'),
    meta: {
      pageTitle: 'داشبورد',
      action: 'show',
      resource: 'Dashboard',
      icon: 'ActivityIcon',
    },
  },
]
